import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useContext } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import {
  ConnectionContext,
  CONNECTION_STATUS,
} from "../context/Connection/ConnectionContext";

const useSocketConnection = () => {
  const { socket } = useContext(AuthContext);
  const { onDisconnected, onReconnecting, onConnected, onReconnectError } =
    useContext(ConnectionContext);
  const wasConnectedRef = useRef(false);
  const toastIdRef = useRef(null);

  useEffect(() => {
    if (!socket || typeof socket.onConnectionEvent !== "function") return;

    const handleConnected = () => {
      const wasDisconnected = onConnected();

      if (wasDisconnected && toastIdRef.current) {
        toast.update(toastIdRef.current, {
          render: "Conexão restaurada",
          type: toast.TYPE.SUCCESS,
          autoClose: 3000,
        });
        toastIdRef.current = null;
      } else if (wasDisconnected) {
        toast.success("Conexão restaurada", { autoClose: 3000 });
      }

      wasConnectedRef.current = true;
    };

    const handleDisconnected = (reason) => {
      onDisconnected(reason);
      wasConnectedRef.current = false;

      if (!toastIdRef.current) {
        toastIdRef.current = toast.error(
          "Conexão perdida. Tentando reconectar...",
          {
            autoClose: false,
            closeOnClick: false,
            draggable: false,
          }
        );
      }
    };

    const handleReconnecting = (attemptNumber) => {
      onReconnecting(attemptNumber);
    };

    const handleReconnectError = (error) => {
      onReconnectError(error);
    };

    socket.onConnectionEvent("connected", handleConnected);
    socket.onConnectionEvent("disconnected", handleDisconnected);
    socket.onConnectionEvent("reconnecting", handleReconnecting);
    socket.onConnectionEvent("reconnect_error", handleReconnectError);

    return () => {
      socket.offConnectionEvent("connected", handleConnected);
      socket.offConnectionEvent("disconnected", handleDisconnected);
      socket.offConnectionEvent("reconnecting", handleReconnecting);
      socket.offConnectionEvent("reconnect_error", handleReconnectError);
    };
  }, [socket, onDisconnected, onReconnecting, onConnected, onReconnectError]);
};

export default useSocketConnection;
